import {
  createMuiTheme,
} from '@material-ui/core/styles';
import {
  ThemePalette,
} from './types';

const YellowDeglaTheme = createMuiTheme({
  palette: {
    primary: {
      main: ThemePalette.PRIMARY_COLOR,
      contrastText: ThemePalette.PRIMARY_TEXT_COLOR,
    },
    secondary: {
      main: ThemePalette.SECONDARY_COLOR,
    },
    text: {
      secondary: ThemePalette.PRIMARY_COLOR,
    },
  },
  overrides: {
    // Applied to the <ul> element
    MuiInputBase: {
      root: {
        minWidth: '180px',
      },
    },
    MuiFormGroup: {
      root: {
        flexDirection: 'row',
      },
    },
    MuiSelect: {
      root: {
        margin: 0,
        minHeight: '0!important',
        backgroundColor: 'transparent!important',
      },
      selectMenu: {
        minHeight: 0,
      },
      select: {
        backgroundColor: 'transparent',
        padding: '10px 10px',
        '&:focus': {
          backgroundColor: 'transparent',
        },
      },
    },
    MuiButton: {
      contained: {
        borderRadius: '20px',
      },
      outlined: {
        borderRadius: '20px',
      },
      text: {
        borderRadius: '20px',
      },
    }
  },
  props: {
    MuiTextField: {
      variant: 'outlined',
    },
    MuiSelect: {
      variant: 'outlined',
    },
  },
});

export default YellowDeglaTheme;
